import React from "react";
import { StepContainer, NavigationButtons, InfoBox } from "../index";
import { useWizard } from "../../wizard";

const custodyLabel: Record<string, string> = {
  ene: "Ene forældremyndighed",
  med: "Fælles forældremyndighed"
};

const DriverConsentSummaryStep: React.FC = () => {
  const { selfServiceData, goNext, goBack } = useWizard();

  const childName = selfServiceData.consentChildName?.trim();
  const childCpr = selfServiceData.consentChildCpr?.trim();
  const custodyType = selfServiceData.dlCustodyType ?? "";

  const primaryName = selfServiceData.dlGuardian1Name?.trim() || selfServiceData.user?.name || "Registreret forælder";
  const primaryEmail = selfServiceData.dlGuardian1Email?.trim() || selfServiceData.user?.email || "";
  const secondaryName = selfServiceData.dlGuardian2Name?.trim();
  const secondaryEmail = selfServiceData.dlGuardian2Email?.trim();
  const notifyChoice = selfServiceData.dlNotifySecondGuardian;

  const notifyCopy = notifyChoice === true
    ? "Ja, forælder 2 informeres via mail/Digital Post"
    : "Nej, mail/Digital Post sendes ikke automatisk";

  const showSecondGuardian = custodyType === "med" && notifyChoice !== undefined;

  return (
    <StepContainer title="Tjek oplysningerne">
      <InfoBox type="info">
        <p>Gennemgå oplysningerne, inden samtykket sendes til underskrift. Du kan stadig gå tilbage og rette, hvis noget ikke stemmer.</p>
      </InfoBox>
      <ul className="summary-list">
        <li>
          <span className="label">Barn</span>
          <span className="value">
            {childName || "Ikke angivet"}
            {childCpr ? ` (${childCpr.slice(0, 6)}-****)` : ""}
          </span>
        </li>
        {custodyType && (
          <li>
            <span className="label">Forældremyndighed</span>
            <span className="value">{custodyLabel[custodyType] ?? custodyType}</span>
          </li>
        )}
        <li>
          <span className="label">Registreret underskriver</span>
          <span className="value">
            {primaryName}
            {primaryEmail ? ` (${primaryEmail})` : ""}
          </span>
        </li>
        {showSecondGuardian && (secondaryName || secondaryEmail) && (
          <li>
            <span className="label">Forælder/værge 2</span>
            <span className="value">
              {secondaryName || "Navn mangler"}
              {secondaryEmail ? ` (${secondaryEmail})` : ""}
            </span>
          </li>
        )}
        {showSecondGuardian && (
          <li>
            <span className="label">Digital besked</span>
            <span className="value">{notifyCopy}</span>
          </li>
        )}
      </ul>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default DriverConsentSummaryStep;
